export default __webpack_public_path__ + "static/media/kayhanbes2.bbc705a3.jpg";